const RegulationFilters = [
  {
    name: 'Group by docket',
    type: 'toggle',
    searchState: 'inbox',
    pages: ['Regulations'],
    value: false,
  },
  {
    name: 'Item type',
    type: 'singleSelect',
    searchState: 'searchResultsSection',
    pages: ['Regulations'],
    prefix: 'regulation-type',
    filterName: 'regulationItemType',
    optionSelected: 'Document',
    options: [{ name: 'Docket name' }, { name: 'Document' }, { name: 'Comment' }],
    separateFilter: true,
  },
  {
    name: 'Group by docket',
    type: 'toggle',
    searchState: 'documentTypeSearch',
    pages: ['Regulations'],
    value: false,
  },

  {
    type: 'membership',
    subtype: 'usAgencyOptions',
    prefix: 'agency',
    name: 'Agency',
    pages: ['Regulations'],
    filterName: 'agency',
    optionSelected: '',
    options: [],
  },
];

const usDepartmentOptions = [{ name: 'Department of Health and Human Services' }];

const usAgencyOptions = [
  { name: 'Agency for Healthcare Research and Quality' },
  { name: 'Agency for Toxic Substances and Disease Registry' },
  { name: 'Aging Administration' },
  { name: 'Centers for Disease Control and Prevention' },
  { name: 'Centers for Medicare & Medicaid Services' },
  { name: 'Child Support Enforcement Office' },
  { name: 'Children and Families Administration' },
  { name: 'Family Assistance Office' },
  { name: 'Food and Drug Administration' },
  { name: 'Health Resources and Services Administration' },
  { name: 'Indian Health Service' },
  { name: 'Inspector General Office, Health and Human Services Department' },
  { name: 'National Institutes of Health' },
  { name: 'National Library of Medicine' },
  { name: 'Program Support Center' },
  { name: 'Public Health Service' },
  { name: 'Refugee Resettlement Office' },
  { name: 'Substance Abuse and Mental Health Services Administration' },
  { name: 'Health Care Finance Administration' },
  { name: 'Community Living Administration' },
  { name: 'Strategic Preparedness and Response Administration' },
];

export { usDepartmentOptions, usAgencyOptions };
export default RegulationFilters;
